import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, tap } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MultiSearchService {

  private apiUrl = `${environment.backendUrl}/api/search`;
  private cache = new Map<string, any>();

  constructor(private http: HttpClient) {}

  getSearchResult(query: string, lang: string = 'en-US'): Observable<any> {
    const trimmed = query.trim();
    if (!trimmed) {
      throw new Error('Search query cannot be empty');
    }

    const cacheKey = `${trimmed.toLowerCase()}_${lang}`;
    if (this.cache.has(cacheKey)) {
      return of(this.cache.get(cacheKey));
    }

    const encodedQuery = encodeURIComponent(trimmed);
    const url = `${this.apiUrl}/${encodedQuery}?language=${encodeURIComponent(lang)}`;
    return this.http.get<any>(url).pipe(
      tap((response) => {
        if (response && response.results) {
          // Limit cache size to prevent memory leaks (keep latest 100 queries)
          if (this.cache.size > 100) {
            const firstKey = this.cache.keys().next().value;
            if (firstKey) this.cache.delete(firstKey);
          }
          this.cache.set(cacheKey, response);
        }
      })
    );
  }
}

